import { getAllSales, updateLegacyOrdersWithOrderNumber } from '../supabase/database';

/**
 * Update semua pesanan yang belum memiliki nomor pesanan
 */
export const migrateSalesWithOrderNumbers = async () => {
  try {
    console.log('Starting migration for sales without order numbers...');
    
    // Use the existing function from firestore.js
    const updatedCount = await updateLegacyOrdersWithOrderNumber();
    
    console.log(`Migration completed! Updated: ${updatedCount} orders`);
    return { updated: updatedCount, errors: 0 };
    
  } catch (error) {
    console.error('Migration failed:', error);
    throw error;
  }
};

/**
 * Check berapa banyak pesanan yang belum memiliki nomor pesanan
 */
export const checkSalesWithoutOrderNumbers = async () => {
  try {
    const sales = await getAllSales();
    const salesWithoutOrderNumber = sales.filter(sale => !sale.noPesanan);
    
    return {
      total: sales.length,
      withoutOrderNumber: salesWithoutOrderNumber.length,
      withOrderNumber: sales.length - salesWithoutOrderNumber.length
    };
  } catch (error) {
    console.error('Error checking sales:', error);
    throw error;
  }
};
